import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import element from './element'
Vue.config.productionTip = false

Vue.use(element)
import { Loading } from 'element-ui';
Vue.use(Loading.directive);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
